module.exports = __webpack_public_path__ + "static/media/defaultCover.71033ee6.PNG";